import React from "react";
import styles from "./LoadingShadeTile.module.css";

export const LoadingShadeTile = () => {
  return <div className={styles.loading} />;
};
